<template>
    <b-spinner v-if="loading" type="grow" />
    <div v-else>
        <b-badge v-for="relation in relationLabel()" variant="dark" :key="relation" class="p-1 m-1 relation"> {{ relation }} </b-badge>
    </div>
</template>

<style scoped>
.relation {
    cursor: pointer;
}

.relation:hover {
    color: #ccc;
}

</style>

<script>
import { template, isArray } from 'lodash'

export default {
    props: {
        field: {
            type: Object
        },

        value: {
            type: Object
        },
    },

    data: function() {
        return {
            loading: true,
            component: null
        }
    },

    methods: {
        relationLabel() {
            try {
                let label = this.field.constraints.relation.label

                let field = this.component.settings.fields.find(f => {
                    return f.key == label
                })

                if (!this.value) {
                    return
                }

                let refObjKey = this.field.relation.key[0]
                let item = this.value[refObjKey + "_RefObj"]

                if (label && item) {
                    if (isArray(item)) {
                        return item.map(i => {
                            if (label.includes("{{") && label.includes("}}")) {
                                return this.parseLabel(i, label)
                            }

                             // is item[label] object with locales
                            if (typeof i[label] === 'object' && i[label].hasOwnProperty("locales")) {
                                return this.$translateLabel(i[label], "__unknown_value__")
                            }

                            return i[label]
                        })
                    }

                    if (label.includes("{{") && label.includes("}}")) {
                        return [this.parseLabel(item, label)]
                    }

                    if (item[label]) {
                        // is item[label] object with locales
                        if (typeof item[label] === 'object' && item[label].hasOwnProperty("locales")) {
                            return [this.$translateLabel(item[label], "__unknown_value__")]
                        }

                        return [item[label]]
                    }
                }

                return [this.$translateLabel(item[label], "__unknown_value__")]
            } catch(err) {
                this.$debugLog(err)
                this.loading = false
            }
        },

        parseLabel(item, label) {
            try {
                const compiled = template(label, {
                    interpolate: /{{([\s\S]+?)}}/g
                })

                const formated = compiled({
                    item,
                    translateLabel: (label, def) => {
                        return this.$translateLabel(label, def)
                    }
                })

                return formated
            } catch(err) {
                this.$debugLog("Relation.vue -> parseLabel", err)
                return label
            }
        },

        normalizeLabel(item, label) {
            if (label.includes("{{") && label.includes("}}")) {
                return this.parseLabel(item, label)
            }

            return label
        }
    },

    mounted() {
        this.$store.dispatch('fetchComponentsSettings', this.field.relation.foreign).then((data) => {
           this.component = data
        }).finally(() => {
            this.loading = false
        })
    }
}
</script>